import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bankName',
})
export class BankNamePipe implements PipeTransform{

  bankCode2Name = {
    'KBANK':'กสิกรไทย',
    'SCB':'ไทยพาณิชย์',
    'BBL':'กรุงเทพ',
    'KTB':'กรุงไทย',
    'BAY':'กรุงศรีฯ',
    'TBANK':'ธนชาต',
    'BBANK':'',
    'PAYSBUY':'เพย์สบาย'
  }

  transform(value: any,type:string):string {
    if(type=='request') {

    }


    return this.bankCode2Name[value];
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/bank_name.pipe.ts